export class AuthenticationError extends Error {
    constructor(reason) {
        const message = `Authentication Error: ${reason.description} (${reason.status.code})`;
        super(message);
        this.reason = reason;
    }
}
/* eslint-disable consistent-return */
const handleResponseError = (reject, metadata, data) => {
    const { status, statusText } = metadata;
    switch (status) {
        case 400:
        case 401: {
            data
                .then(details => {
                const error = new AuthenticationError({
                    status: {
                        code: status,
                        text: statusText
                    },
                    description: details
                });
                return reject(error);
            })
                .catch(dataFetchError => {
                return reject(dataFetchError);
            });
            break;
        }
        default:
            return reject(new Error(`Error encountered while getting access token from auth server: ${metadata}`));
    }
};
export default handleResponseError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzcG9uc2UtZXJyb3ItaGFuZGxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvcmVzcG9uc2UtZXJyb3ItaGFuZGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTQSxNQUFNLE9BQU8sbUJBQW9CLFNBQVEsS0FBSztJQUc1QyxZQUFZLE1BQW1CO1FBQzdCLE1BQU0sT0FBTyxHQUFXLHlCQUF5QixNQUFNLENBQUMsV0FBVyxLQUFLLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxHQUFHLENBQUM7UUFDOUYsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ2YsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7SUFDdkIsQ0FBQztDQUNGO0FBQ0Qsc0NBQXNDO0FBRXRDLE1BQU0sbUJBQW1CLEdBQUcsQ0FDMUIsTUFBOEIsRUFDOUIsUUFBMEIsRUFDMUIsSUFBa0IsRUFDUSxFQUFFO0lBQzVCLE1BQU0sRUFBRSxNQUFNLEVBQUUsVUFBVSxFQUFFLEdBQUcsUUFBUSxDQUFDO0lBRXhDLFFBQVEsTUFBTSxFQUFFO1FBQ2QsS0FBSyxHQUFHLENBQUM7UUFDVCxLQUFLLEdBQUcsQ0FBQyxDQUFDO1lBQ1IsSUFBSTtpQkFDRCxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ2QsTUFBTSxLQUFLLEdBQUcsSUFBSSxtQkFBbUIsQ0FBQztvQkFDcEMsTUFBTSxFQUFFO3dCQUNOLElBQUksRUFBRSxNQUFNO3dCQUNaLElBQUksRUFBRSxVQUFVO3FCQUNqQjtvQkFDRCxXQUFXLEVBQUUsT0FBTztpQkFDckIsQ0FBQyxDQUFDO2dCQUNILE9BQU8sTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQ3ZCLENBQUMsQ0FBQztpQkFDRCxLQUFLLENBQUMsY0FBYyxDQUFDLEVBQUU7Z0JBQ3RCLE9BQU8sTUFBTSxDQUFDLGNBQWMsQ0FBQyxDQUFDO1lBQ2hDLENBQUMsQ0FBQyxDQUFDO1lBQ0wsTUFBTTtTQUNQO1FBQ0Q7WUFDRSxPQUFPLE1BQU0sQ0FDWCxJQUFJLEtBQUssQ0FDUCxrRUFBa0UsUUFBUSxFQUFFLENBQzdFLENBQ0YsQ0FBQztLQUNMO0FBQ0gsQ0FBQyxDQUFDO0FBRUYsZUFBZSxtQkFBbUIsQ0FBQyJ9